export default {"src":"/_next/static/media/brand-new-badge.ff006bba.svg","height":190,"width":191,"blurWidth":0,"blurHeight":0};